// 이 파일은 순환 참조를 피하기 위해 별도로 분리되었습니다.
// scripts/generate-json-declarations.ts와 constants.ts에서 공통으로 사용됩니다.

export const supportedLocales = ['en', 'vi', 'zh-CN', 'zh-TW', 'ru', 'ja', 'en-AE'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];
export const defaultLocale: SupportedLocale = 'en';
